var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { FiAlertCircle, FiTrash2 } from 'react-icons/fi';
import * as _ from 'lodash';
import { get } from 'lodash';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import colors from '../utils/colors';
import { Table, TableCell, TableCellContent, TableCellContentNoWrap, TableHead, TableHeadCell, TableRow, } from './BrandTable';
import OptionSelect from './OptionSelect';
import { BrandButtonTertiary } from './BrandButton';
import { FloorSize, FloorSizeValues } from '../types/floorplan';
import { Subtitle } from './BrandText';
import { ScrollableContainer, SCROLLBAR_WIDTH_CSS } from './ScrollableContainer';
import { Header } from '../components/Header';
import { ConfirmationDialog } from './ConfirmationDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CheckBox from './BrandCheckBox';
var FloorPlanUploadContainer = styled(ScrollableContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100% - 48px);\n  padding: 24px 32px;\n  padding-right: calc(32px + ", ");\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"], ["\n  height: calc(100% - 48px);\n  padding: 24px 32px;\n  padding-right: calc(32px + ", ");\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"])), SCROLLBAR_WIDTH_CSS, colors.WHITE, colors.TP_GRAY);
var PlanDescription = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.42px;\n  line-height: 18px;\n  margin-top: 16px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.42px;\n  line-height: 18px;\n  margin-top: 16px;\n"])), colors.TEXT_DEFAULT);
var PlaceholderCell = styled(TableCell)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  padding: 0px;\n"], ["\n  color: ", ";\n  padding: 0px;\n"])), colors.GRAY);
var PlaceholderInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 8px 16px;\n  border: 0px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.4px;\n  line-height: 14px;\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 8px 16px;\n  border: 0px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.4px;\n  line-height: 14px;\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"])), colors.TEXT_DEFAULT, colors.TP_TURQUOISE);
var FileUploadLabel = styled.label(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  padding-left: 16px;\n"], ["\n  display: block;\n  padding-left: 16px;\n"])));
var FileUploadInfo = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  display: inline-block;\n  text-transform: uppercase;\n"])), function (props) { return props.theme.primaryColor || colors.TP_TURQUOISE; });
var FileUploadName = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  padding-right: 16px;\n  display: inline-block;\n"], ["\n  color: ", ";\n  padding-right: 16px;\n  display: inline-block;\n"])), colors.TEXT_DEFAULT);
var FileUploadInput = styled.input(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var DeleteBtnContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: absolute;\n  top: 7px;\n  left: calc(100% + 16px);\n\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 7px;\n  left: calc(100% + 16px);\n\n  color: ", ";\n"])), function (props) { return props.theme.primaryColorLight || colors.RED; });
var AddFloorBtn = styled(BrandButtonTertiary)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var FloorPlanThumbs = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 16px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 16px;\n"])));
var FloorPlanThumb = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  height: 165px;\n  width: 206px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border: 2px solid ", ";\n  background-color: ", ";\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n"], ["\n  height: 165px;\n  width: 206px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border: 2px solid ", ";\n  background-color: ", ";\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n"])), function (props) { return props.theme.supportingColorLight || colors.BLUE; }, colors.WHITE);
var ErrorBox = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #e4cece;\n  color: ", ";\n  border-radius: 5px;\n  padding: 15px;\n  max-width: 300px;\n  font-size: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #e4cece;\n  color: ", ";\n  border-radius: 5px;\n  padding: 15px;\n  max-width: 300px;\n  font-size: 16px;\n"])), colors.RED);
function generateOption(value) {
    return {
        value: value,
        label: _.capitalize(_.toString(value)),
    };
}
var FloorPlanUpload = /** @class */ (function (_super) {
    __extends(FloorPlanUpload, _super);
    function FloorPlanUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.renderUploadedFloorPlans = function () {
            return _this.props.floorPlanStore.floors.map(function (floor) {
                return React.createElement(FloorPlanThumb, { key: floor.id, style: { backgroundImage: "url(" + floor.image.url + ")" } });
            });
        };
        _this.handleChange = function (selectorFiles) {
            if (!_.isNil(selectorFiles) && !_.isNil(selectorFiles[0])) {
                var selectedFile = selectorFiles[0];
                _this.setLayoutFile(selectedFile);
            }
        };
        _this.onSaveClicked = function () { return __awaiter(_this, void 0, void 0, function () {
            var floorPlanStore, _a, layoutFile, floorName, labelColor, floorSize, isDefault;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        floorPlanStore = this.props.floorPlanStore;
                        _a = this.state, layoutFile = _a.layoutFile, floorName = _a.floorName, labelColor = _a.labelColor, floorSize = _a.floorSize, isDefault = _a.isDefault;
                        if (!this.validateInputs()) return [3 /*break*/, 2];
                        // TODO: some loading indicator?
                        return [4 /*yield*/, floorPlanStore.saveNewLayout(floorName, layoutFile, labelColor.value, floorSize.value, isDefault)];
                    case 1:
                        // TODO: some loading indicator?
                        _b.sent();
                        // Reset input state
                        this.setState({
                            floorName: '',
                            layoutFile: null,
                            floorSize: generateOption(this.getLastFloorSize()),
                            labelColor: generateOption(get(this.props, 'labelsStore.labelColors[0]', 'None')),
                            isDefault: false,
                        });
                        this.fileInput.value = '';
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onDeleteClicked = function (floor) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    isConfirmDialogOpen: true,
                    confirmMessage: "You're about to delete floor plan for floor number " + floor.title,
                    floorIdToDelete: floor.id,
                });
                return [2 /*return*/];
            });
        }); };
        _this.validateInputs = function () {
            var floorPlanStore = _this.props.floorPlanStore;
            var _a = _this.state, layoutFile = _a.layoutFile, floorName = _a.floorName;
            if (!floorName) {
                _this.setState({ inputError: 'Please enter a floor number' });
                return false;
            }
            if (!layoutFile) {
                _this.setState({ inputError: 'Please upload a floor plan' });
                return false;
            }
            if (_.includes(floorPlanStore.floors.map(function (floor) { return floor.title; }), floorName)) {
                _this.setState({ inputError: 'Floor number or name must be unique' });
                return false;
            }
            _this.setState({ inputError: null });
            return true;
        };
        _this.renderNewRow = function () {
            var _a = _this.state, floorName = _a.floorName, labelColor = _a.labelColor, layoutFile = _a.layoutFile, floorSize = _a.floorSize, isDefault = _a.isDefault;
            var labelColors = get(_this.props, 'labelsStore.labelColors', ['None']);
            return (React.createElement(TableRow, null,
                React.createElement(PlaceholderCell, null,
                    React.createElement(PlaceholderInput, { type: "number", placeholder: "Type floor number", value: floorName || '', onChange: function (e) { return _this.setFloorName(e.target.value); } })),
                React.createElement(PlaceholderCell, { align: "right" },
                    React.createElement(OptionSelect, { value: floorSize, onChange: _this.setFloorSize, options: _.map(FloorSizeValues, generateOption) })),
                React.createElement(TableCell, { align: "right" },
                    React.createElement(OptionSelect, { value: labelColor, onChange: _this.setLabel, options: _.map(labelColors, generateOption) })),
                React.createElement(TableCell, { align: "right" },
                    React.createElement(CheckBox, { checked: isDefault, onChange: function () { return _this.setIsDefault(!_this.state.isDefault); } })),
                React.createElement(PlaceholderCell, { align: "right" },
                    React.createElement(FileUploadLabel, null,
                        !layoutFile && React.createElement(FileUploadInfo, null, "Browse..."),
                        React.createElement(FileUploadName, null, layoutFile && layoutFile.name),
                        layoutFile && React.createElement(FileUploadInfo, null, "Change..."),
                        React.createElement(FileUploadInput, { type: "file", accept: ".jpg,.jpeg,.png", onChange: function (e) { return _this.handleChange(e.target.files); }, ref: function (ref) { return (_this.fileInput = ref); } })))));
        };
        _this.state = {
            floorName: '',
            layoutFile: null,
            labelColor: generateOption(get(props, 'labelsStore.labelColors[0]', 'None')),
            inputError: null,
            floorSize: generateOption(_this.getLastFloorSize()),
            confirmMessage: '',
            isConfirmDialogOpen: false,
            floorIdToDelete: null,
            updatingFloorLabel: false,
            shouldShowNotification: false,
            notificationText: '',
            notificationColor: 'success',
            isDefault: false,
        };
        _this.fileInput = React.createRef();
        _this.setFloorName = _this.setFloorName.bind(_this);
        _this.setLayoutFile = _this.setLayoutFile.bind(_this);
        _this.setLabel = _this.setLabel.bind(_this);
        _this.setFloorSize = _this.setFloorSize.bind(_this);
        _this.getLastFloorSize = _this.getLastFloorSize.bind(_this);
        _this.onDeleteClicked = _this.onDeleteClicked.bind(_this);
        _this.onConfirmBoxClose = _this.onConfirmBoxClose.bind(_this);
        _this.setIsDefault = _this.setIsDefault.bind(_this);
        return _this;
    }
    FloorPlanUpload.prototype.setFloorName = function (floorName) {
        this.setState({ floorName: floorName });
    };
    FloorPlanUpload.prototype.setLayoutFile = function (layoutFile) {
        this.setState({ layoutFile: layoutFile });
    };
    FloorPlanUpload.prototype.setLabel = function (labelColor) {
        this.setState({ labelColor: labelColor });
    };
    FloorPlanUpload.prototype.setFloorSize = function (floorSize) {
        this.setState({ floorSize: floorSize });
    };
    FloorPlanUpload.prototype.getLastFloorSize = function () {
        var floorPlanStore = this.props.floorPlanStore;
        // get the last saved floor
        var lastFloor = _.last(floorPlanStore.floors);
        return get(lastFloor, 'floorSize', FloorSize.SMALL);
    };
    FloorPlanUpload.prototype.setIsDefault = function (isDefault) {
        this.setState({ isDefault: isDefault });
    };
    FloorPlanUpload.prototype.onConfirmBoxClose = function (isConfirmed) {
        return __awaiter(this, void 0, void 0, function () {
            var floorPlanStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        floorPlanStore = this.props.floorPlanStore;
                        if (!(isConfirmed && this.state.floorIdToDelete)) return [3 /*break*/, 2];
                        return [4 /*yield*/, floorPlanStore.deleteLayout(this.state.floorIdToDelete)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setState({
                            isConfirmDialogOpen: false,
                            confirmMessage: '',
                            floorIdToDelete: null,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FloorPlanUpload.prototype.render = function () {
        var _this = this;
        var floorPlanStore = this.props.floorPlanStore;
        var inputError = this.state.inputError;
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Specify floors"),
            React.createElement(FloorPlanUploadContainer, null,
                React.createElement(PlanDescription, null,
                    "Give the floors numbers or names, specify their label colors and upload the floor plans in either JPEG or PNG form. You can upload multiple separate maps or layouts (eg. different floors or buildings).",
                    ' '),
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement("tr", null,
                            React.createElement(TableHeadCell, null, "Floor number"),
                            React.createElement(TableHeadCell, { align: "right" }, "Floor size"),
                            React.createElement(TableHeadCell, { align: "right" }, "Label color"),
                            React.createElement(TableHeadCell, { align: "right" }, "Default"),
                            React.createElement(TableHeadCell, { align: "right" }, "Upload file"))),
                    React.createElement("tbody", null,
                        floorPlanStore.floors.map(function (floor) {
                            return (React.createElement(TableRow, { key: floor.title },
                                React.createElement(TableCell, { align: "right" }, floorPlanStore.updatingFloor && floorPlanStore.updatingFloor.id === floor.id ? (React.createElement(CircularProgress, null)) : (React.createElement(OptionSelect, { value: {
                                        value: floor.title,
                                        label: _.capitalize(floor.title),
                                    }, onChange: function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        var error_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, 3, 4]);
                                                    this.setState({
                                                        updatingFloorLabel: true,
                                                    });
                                                    return [4 /*yield*/, floorPlanStore.updateFloor(floor.id, {
                                                            label_color: floor.labelColor,
                                                            isDefault: floor.isDefault,
                                                            floor_name: event.value.toString(),
                                                        })];
                                                case 1:
                                                    _a.sent();
                                                    this.setState({
                                                        notificationColor: 'success',
                                                        notificationText: 'Successfully updated floor number',
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 2:
                                                    error_1 = _a.sent();
                                                    this.setState({
                                                        notificationColor: 'error',
                                                        notificationText: 'Failed to update floor number',
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    this.setState({
                                                        updatingFloorLabel: false,
                                                        shouldShowNotification: true,
                                                    });
                                                    return [7 /*endfinally*/];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); }, options: _.map(floorPlanStore.floorNames, generateOption) }))),
                                React.createElement(TableCell, { align: "right" },
                                    React.createElement(TableCellContent, null, _.capitalize(floor.floorSize))),
                                React.createElement(TableCell, { align: "right" },
                                    React.createElement(TableCellContent, null, floorPlanStore.updatingFloor && floorPlanStore.updatingFloor.id === floor.id ? (React.createElement(CircularProgress, null)) : (React.createElement(OptionSelect, { value: {
                                            value: floor.labelColor,
                                            label: _.capitalize(floor.labelColor),
                                        }, onChange: function (event) { return __awaiter(_this, void 0, void 0, function () {
                                            var error_2;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        _a.trys.push([0, 2, 3, 4]);
                                                        this.setState({
                                                            updatingFloorLabel: true,
                                                        });
                                                        return [4 /*yield*/, floorPlanStore.updateFloor(floor.id, {
                                                                label_color: event.value,
                                                                isDefault: floor.isDefault,
                                                                floor_name: floor.title.toString(),
                                                            })];
                                                    case 1:
                                                        _a.sent();
                                                        this.setState({
                                                            notificationColor: 'success',
                                                            notificationText: 'Successfully updated floor label',
                                                        });
                                                        return [3 /*break*/, 4];
                                                    case 2:
                                                        error_2 = _a.sent();
                                                        this.setState({
                                                            notificationColor: 'error',
                                                            notificationText: 'Failed to update floor label',
                                                        });
                                                        return [3 /*break*/, 4];
                                                    case 3:
                                                        this.setState({
                                                            updatingFloorLabel: false,
                                                            shouldShowNotification: true,
                                                        });
                                                        return [7 /*endfinally*/];
                                                    case 4: return [2 /*return*/];
                                                }
                                            });
                                        }); }, options: _.map(_this.props.labelsStore.labelColors, generateOption) })))),
                                React.createElement(TableCell, { align: "right" }, floorPlanStore.updatingFloor && floorPlanStore.updatingFloor.id === floor.id ? (React.createElement(CircularProgress, null)) : (React.createElement(CheckBox, { checked: floor.isDefault, onChange: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var error_3;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, 3, 4]);
                                                    this.setState({
                                                        updatingFloorLabel: true,
                                                    });
                                                    return [4 /*yield*/, floorPlanStore.updateFloor(floor.id, {
                                                            label_color: floor.labelColor,
                                                            isDefault: !floor.isDefault,
                                                            floor_name: floor.title.toString(),
                                                        })];
                                                case 1:
                                                    _a.sent();
                                                    this.setState({
                                                        notificationColor: 'success',
                                                        notificationText: 'Sucessfully updated default floor',
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 2:
                                                    error_3 = _a.sent();
                                                    this.setState({
                                                        notificationColor: 'error',
                                                        notificationText: 'Failed to update default floor',
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    this.setState({
                                                        updatingFloorLabel: false,
                                                        shouldShowNotification: true,
                                                    });
                                                    return [7 /*endfinally*/];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); } }))),
                                React.createElement(TableCell, { align: "right", style: { position: 'relative' } },
                                    React.createElement(TableCellContentNoWrap, null, floor.image.title),
                                    React.createElement(DeleteBtnContainer, { onClick: function () { return _this.onDeleteClicked(floor); } },
                                        React.createElement(FiTrash2, { size: 16 })))));
                        }),
                        this.renderNewRow())),
                inputError && (React.createElement(ErrorBox, null,
                    inputError,
                    React.createElement(FiAlertCircle, { size: 30, color: colors.RED }))),
                React.createElement(AddFloorBtn, { onClick: this.onSaveClicked }, "Add floor"),
                React.createElement(Subtitle, null, "Uploaded floor plans"),
                React.createElement(FloorPlanThumbs, null, this.renderUploadedFloorPlans())),
            React.createElement(ConfirmationDialog, { isOpen: this.state.isConfirmDialogOpen, title: "Are you sure you want to delete?", content: React.createElement("p", null, this.state.confirmMessage), onClose: this.onConfirmBoxClose }),
            React.createElement(Snackbar, { open: this.state.shouldShowNotification, autoHideDuration: 3000, onClose: function () {
                    _this.setState({
                        shouldShowNotification: false,
                    });
                } },
                React.createElement(Alert, { variant: "filled", severity: this.state.notificationColor, onClose: function () {
                        _this.setState({
                            shouldShowNotification: false,
                            notificationText: '',
                        });
                    } }, this.state.notificationText))));
    };
    FloorPlanUpload = __decorate([
        inject('floorPlanStore'),
        inject('labelsStore'),
        observer
    ], FloorPlanUpload);
    return FloorPlanUpload;
}(Component));
export default FloorPlanUpload;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=FloorPlanUpload.js.map